export const LOGGED_OUT_CONTAINER_TAG_NAME = 'logged-out-container';
